import { render, staticRenderFns } from "./quesView.vue?vue&type=template&id=3a58f402"
import script from "./quesView.vue?vue&type=script&lang=js"
export * from "./quesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports